<template>
  <div class="animated fadeInRight ecommerce">
    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>{{ $t('basePrivilegeManage.queryCondition') }}</span>
          </div>
          <el-form :model="basePrivilegeManageInfo.conditions" class="search-form text-left" inline>
            <el-form-item>
              <el-input v-model="basePrivilegeManageInfo.conditions.name"
                :placeholder="$t('basePrivilegeManage.inputPrivilegeName')" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="basePrivilegeManageInfo.conditions.pId"
                :placeholder="$t('basePrivilegeManage.inputPrivilegeCode')" clearable>
              </el-input>
            </el-form-item>
            <el-button type="primary" size="small" @click="_queryBasePrivilegeMethod()">
              <i class="el-icon-search"></i>
              {{ $t('basePrivilegeManage.query') }}
            </el-button>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>{{ $t('basePrivilegeManage.privilegeInfo') }}</span>
            <div>
              <el-button type="primary" size="small" @click="_openAddBasePrivilegeModal()">
                <i class="el-icon-plus"></i>
                {{ $t('basePrivilegeManage.addPrivilege') }}
              </el-button>
            </div>
          </div>

          <el-table :data="basePrivilegeManageInfo.basePrivileges" border style="width: 100%">
            <el-table-column prop="pId" :label="$t('basePrivilegeManage.privilegeId')" align="center">
            </el-table-column>
            <el-table-column prop="name" :label="$t('basePrivilegeManage.privilegeName')" align="center">
            </el-table-column>
            <el-table-column prop="resource" :label="$t('basePrivilegeManage.resourcePath')" align="center">
            </el-table-column>
            <el-table-column prop="domain" :label="$t('basePrivilegeManage.merchantType')" align="center">
            </el-table-column>
            <el-table-column prop="stName" :label="$t('basePrivilegeManage.merchantName')" align="center">
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('basePrivilegeManage.createTime')" align="center">
            </el-table-column>
            <el-table-column :label="$t('basePrivilegeManage.operation')" align="center">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button size="mini" @click="_openEditBasePrivilegeModel(scope.row)">
                    {{ $t('basePrivilegeManage.edit') }}
                  </el-button>
                  <el-button size="mini" type="danger" @click="_openDeleteBasePrivilegeModel(scope.row)">
                    {{ $t('basePrivilegeManage.delete') }}
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination @current-change="handleCurrentChange" :current-page="basePrivilegeManageInfo.conditions.page"
            :page-size="basePrivilegeManageInfo.conditions.row" layout="total, prev, pager, next"
            :total="basePrivilegeManageInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-base-privilege ref="addBasePrivilege" @success="queryBasePrivilege"></add-base-privilege>
    <edit-base-privilege ref="editBasePrivilege" @success="queryBasePrivilege"></edit-base-privilege>
    <delete-base-privilege ref="deleteBasePrivilege" @success="queryBasePrivilege"></delete-base-privilege>
  </div>
</template>

<script>
import { listBasePrivileges } from '@/api/dev/basePrivilegeApi'
import AddBasePrivilege from '@/components/dev/addBasePrivilege/addBasePrivilege'
import EditBasePrivilege from '@/components/dev/editBasePrivilege/editBasePrivilege'
import DeleteBasePrivilege from '@/components/dev/deleteBasePrivilege/deleteBasePrivilege'

export default {
  name: 'BasePrivilegeManage',
  components: {
    AddBasePrivilege,
    EditBasePrivilege,
    DeleteBasePrivilege
  },
  data() {
    return {
      basePrivilegeManageInfo: {
        basePrivileges: [],
        total: 0,
        records: 1,
        moreCondition: false,
        name: '',
        mId: '',
        conditions: {
          name: '',
          pId: '',
          domain: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.basePrivilegeManageInfo.mId = this.$route.query.mId
    this._listBasePrivileges(this.basePrivilegeManageInfo.conditions.page, this.basePrivilegeManageInfo.conditions.row)
  },
  methods: {
    handleCurrentChange(val) {
      this._listBasePrivileges(val, this.basePrivilegeManageInfo.conditions.row)
    },
    queryBasePrivilege() {
      this._listBasePrivileges(1, this.basePrivilegeManageInfo.conditions.row)
    },
    _listBasePrivileges(page, rows) {
      this.basePrivilegeManageInfo.conditions.page = page
      this.basePrivilegeManageInfo.conditions.row = rows
      this.basePrivilegeManageInfo.conditions.mId = this.basePrivilegeManageInfo.mId

      listBasePrivileges(this.basePrivilegeManageInfo.conditions)
        .then(response => {
          this.basePrivilegeManageInfo.total = response.total
          this.basePrivilegeManageInfo.records = response.records
          this.basePrivilegeManageInfo.basePrivileges = response.data
        })
        .catch(error => {
          console.log('请求失败处理', error)
        })
    },
    _openAddBasePrivilegeModal() {
      this.$refs.addBasePrivilege.open({
        mId: this.basePrivilegeManageInfo.mId
      })
    },
    _openEditBasePrivilegeModel(row) {
      this.$refs.editBasePrivilege.open(row)
    },
    _openDeleteBasePrivilegeModel(row) {
      this.$refs.deleteBasePrivilege.open(row)
    },
    _queryBasePrivilegeMethod() {
      this._listBasePrivileges(1, this.basePrivilegeManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-col {
  width: 100%;
}
</style>